import { SocialLinks } from 'models/IRestaurantInfo'

export interface SocialLinksProps {
  Links: SocialLinks
}

export const useSocialLinks = (props: SocialLinksProps) => {
  return {
    ...props,
  }
}
